document.addEventListener('DOMContentLoaded', function () {

  function updateStaticPrices() {

    const cards = document.querySelectorAll('.kaching-bundles__bar');

    const guaranteeWrapper = document.querySelector('.addToCart--secure');

    const guaranteeTexts = document.querySelectorAll(
      '.guarantee_text, .guarantee-title strong'
    );

    if (cards.length < 3) {
      setTimeout(updateStaticPrices, 300);
      return;
    }

    // Detect currency
    const currency = Shopify.currency.active;

    // Default USD
    let prices = [
      '$37 per pack',
      '$19 per pack',
      '$19 per pack'
    ];

    let quarterlyText = '3x bags delivered quarterly at $26/each';

    // UK
    if (currency === 'GBP') {

      prices = [
        '£28 per pack',
        '£14.50 per pack',
        '£14.50 per pack'
      ];

      quarterlyText = '3x bags delivered quarterly at £19.50/each';

    }

    // Australia
    if (currency === 'AUD') {

      prices = [
        '$52 per pack',
        '$27 per pack',
        '$27 per pack'
      ];

      quarterlyText = '3x bags delivered quarterly at $36.5/each';

    }

    // Europe
    if (currency === 'EUR') {

      prices = [
        '€32 per pack',
        '€17 per pack',
        '€17 per pack'
      ];

      quarterlyText = '3x bags delivered quarterly at €22.5/each';

    }

    // New Zealand
    if (currency === 'NZD') {

      prices = [
        '$64 per pack',
        '$33 per pack',
        '$33 per pack'
      ];

      quarterlyText = '3x bags delivered quarterly at $44.5/each';

    }

    // Update .second_quaterly text
    const quarterlyElement = document.querySelector('.second_quaterly');

    if (quarterlyElement) {
      quarterlyElement.textContent = quarterlyText;
    }

    // Update guarantee section
    function updateGuarantee(days) {

      if (guaranteeWrapper) {

        guaranteeWrapper.innerHTML = `
          <img
            src="https://cdn.shopify.com/s/files/1/0779/8459/6252/files/shield.png?v=1753865507"
            width="auto"
            height="auto"
            alt="gurantee"
          >
          <span>${days} Day Money-Back Guarantee</span>
        `;

      }

      guaranteeTexts.forEach((el) => {
        el.textContent = `${days} Days`;
      });

    }

    // Default state
    updateGuarantee(90);

    cards.forEach((card, index) => {

      const pricing = card.querySelector('.kaching-bundles__bar-pricing');

      if (pricing && !pricing.querySelector('.custom-pack-price')) {

        pricing.insertAdjacentHTML(
          'beforeend',
          `<span class="custom-pack-price">${prices[index]}</span>`
        );

      }

      card.addEventListener('click', function () {

        const days = index === 0 ? 30 : 90;

        updateGuarantee(days);

      });

    });

  }

  updateStaticPrices();

});